import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3a65eda8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auth-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-form__title" }, "Вход в приложение \"Пионер\"", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-form__subtitle" }, "Выберите счёт для входа в личный кабинет", -1))
const _hoisted_4 = {
  key: 0,
  class: "auth-form__subtitle"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "text-xl font-bold" }
const _hoisted_7 = { class: "text-xs text-gray-400" }
const _hoisted_8 = { class: "text-xs text-gray-400" }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "auth-form__subtitle" }, "Перенаправляю на ваш счёт...", -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 3 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "auth-form__subtitle" }, "Счета отсутствуют", -1))
const _hoisted_14 = [
  _hoisted_13
]

import { ref, onMounted, onUnmounted } from "vue";
import { useRouter } from "vue-router";
import { initBridge } from "@/api/interceptors";
import { useMaxValidation } from "@/use/useMaxValidation";
import { useAuth } from "@/use/useAuth";

import UiCard from "@/plugins/ui/components/card/UiCard.vue";
import UiGroup from "@/plugins/ui/components/group/UiGroup.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChooseScoreForm',
  setup(__props) {

const { scoreListByMax } = useMaxValidation();
const { logout } = useAuth();
const router = useRouter();

const bridgeData = ref<any>(null);
const users = ref<any>(null);
const loading = ref<boolean>(true);
const error = ref<any>(null);
const userCount = ref<number>(0);

async function checkPlatformData() {
  bridgeData.value = await initBridge();

  const { platform, initData } = bridgeData.value;

  if (platform === "unknown") {
    error.value = "Не удалось определить платформу";
    loading.value = false;
    return;
  }

  if (!initData) {
    error.value = "initData отсутствует";
    loading.value = false;
    return;
  }

  try {
    if (process.env.VUE_APP_FEATURE_TELEGRAM === "true" && platform === "telegram") {
      const { useTgValidation } = await import("@/use/useTgValidation");
      const { scoreListByTg } = useTgValidation();
      users.value = await scoreListByTg(initData);
    } else if (platform === "max") {
      users.value = await scoreListByMax(initData);
    }

    userCount.value = users.value ? users.value.length : 0;

    if (userCount.value === 1) {
      await selectScore(users.value[0]);
    }
  } catch (e) {
    error.value = e;
    users.value = null;
  } finally {
    loading.value = false;
  }
}

async function selectScore(user: any): Promise<void> {
  const platform = bridgeData.value?.platform;

  const params = new URLSearchParams();
  params.append("score_id", user.score_id.toString());

  const routeMap: Record<string, string> = {
    max: "/max-login",
  };

  if (process.env.VUE_APP_FEATURE_TELEGRAM === "true") {
    routeMap.telegram = "/tg-login";
  }

  const route = routeMap[platform] ?? "/max-login";
  await router.push(`${route}?${params.toString()}`);
}

onMounted(async () => {
  await logout();
  await checkPlatformData();
});

onUnmounted(() => {
  loading.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "Загрузка..."))
      : (userCount.value > 1)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(UiGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                  return (_openBlock(), _createBlock(UiCard, {
                    key: user.id,
                    onClick: ($event: any) => (selectScore(user))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createElementVNode("h3", _hoisted_6, _toDisplayString(user?.surname) + " " + _toDisplayString(user?.name) + " " + _toDisplayString(user?.description), 1),
                        _createElementVNode("p", _hoisted_7, " Номер счёта: " + _toDisplayString(user?.score_id), 1),
                        _createElementVNode("p", _hoisted_8, _toDisplayString(user?.school_name), 1)
                      ])
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            })
          ]))
        : (userCount.value === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
          : (_openBlock(), _createElementBlock("div", _hoisted_12, _hoisted_14))
  ]))
}
}

})